import * as React from "react";
import { ScoreboardHeaderRow, ScoreboardRow } from "..";
export class SoccerScoreboard extends React.PureComponent {
    render() {
        const { participant1data, participant2data } = this.props.scores;
        return (React.createElement("table", { className: "rj-aggregate-scoreboard" },
            React.createElement("thead", { className: "rj-aggregate-scoreboard-heading" },
                React.createElement(ScoreboardHeaderRow, { dict: this.props.dict, scoresKeys: Object.keys(participant1data), slideUp: this.props.slideUp })),
            React.createElement("tbody", { className: "rj-aggregate-scoreboard-body" },
                React.createElement(ScoreboardRow, { dict: this.props.dict, scoresData: participant1data }),
                React.createElement(ScoreboardRow, { dict: this.props.dict, scoresData: participant2data }))));
    }
}
//# sourceMappingURL=SoccerScoreboard.js.map